export let data = [
	{
		name: "MVIS + CMU or Concrete",
		description:
			"Use our Masonry Veneer Installation System (MVIS) with Concrete Masonry Units (CMU) or concrete to save time and money",
		proCon: [
			"Faster Application Time",
			"Lower overall install cost",
			"Available with multiple warranties",
		],
		products: [
			{
				id: 1.1,
				warranty: 1,
				name: "MVIS Veneer Mortar (least coverage)",
				material: 1.61,
				time: 252,
				labor: 0,
				total: 0,
			},
			{
				id: 1.2,
				warranty: 25,
				name: "MVIS Air and Water Barrier",
				material: 1.99,
				time: 20,
				labor: 0,
				total: 0,
			},
		],

		finalTotal: {
			material: 0,
			time: 0,
			labor: 0,
			total: 0,
		},
	},
	{
		name: "Lath Scratch + Type S",
		description: "Use a traditional Lath Scratch and Type S Installation",
		proCon: [
			"Slower Application Time",
			"Higher overall install cost",
			"No warranty",
		],
		products: [
			{
				id: 2.1,
				warranty: 0,
				name: "1st Layer of Building Felt",
				material: 0.12,
				time: 36,
				labor: 0,
				total: 0,
			},
			{
				id: 2.2,
				warranty: 0,
				name: "2nd Layer of Building Felt",
				material: 0.12,
				time: 36,
				labor: 0,
				total: 0,
			},
			{
				id: 2.3,
				warranty: 0,
				name: "Metal Lath",
				material: 0.99,
				time: 9,
				labor: 0,
				total: 0,
			},
			{
				id: 2.4,
				warranty: 0,
				name: "Metal Lath Fasteners",
				material: 0.12,
				time: 7.5,
				labor: 0,
				total: 0,
			},
			{
				id: 2.5,
				warranty: 0,
				name: 'Leveling & Scratch Coat - 1/2"',
				material: 0.59,
				time: 281,
				labor: 0,
				total: 0,
			},
			{
				id: 2.6,
				warranty: 0,
				name: 'Type S Mortar (Setting Stone) - 1/2"',
				material: 0.59,
				time: 252,
				labor: 0,
				total: 0,
			},
		],
		finalTotal: {
			material: 0,
			time: 0,
			labor: 0,
			total: 0,
		},
	},

	{
		name: "MVIS + CBB",
		description:
			"Use our Masonry Veneer Installation System (MVIS) with a Cement Backer Board (CBB)",
		proCon: [
			"Faster Application Time",
			"Lower overall install cost",
			"Available with multiple warranties",
		],
		products: [
			{
				id: 3.1,
				warranty: 1,
				name: `Permabase Board (1/2"x4'x8')`,
				material: 1.31,
				time: 9,
				labor: 0,
				total: 0,
			},
			{
				id: 3.2,
				warranty: 1,
				name: `Cement Board Fastener (1.7/sf)`,
				material: 0.15,
				time: 11,
				labor: 0,
				total: 0,
			},
			{
				id: 3.3,
				warranty: 1,
				name: `Fiberglass Mesh/Mortar (3"tape/sf)`,
				material: 0.15,
				time: 30,
				labor: 0,
				total: 0,
			},
			{
				id: 3.4,
				warranty: 1,
				name: "MVIS Veneer Mortar (least coverage)",
				material: 1.61,
				time: 252,
				labor: 0,
				total: 0,
			},

			{
				id: 3.5,
				warranty: 15,
				name: "MVIS Air and Water Barrier",
				material: 1.99,
				time: 20,
				labor: 0,
				total: 0,
			},
		],

		finalTotal: {
			material: 0,
			time: 0,
			labor: 0,
			total: 0,
		},
	},

	{
		name: "Lath Scratch + Type S",
		description: "Use a traditional Lath Scratch and Type S Installation",
		proCon: [
			"Slower Application Time",
			"Higher overall install cost",
			"No warranty",
		],
		products: [
			{
				id: 4.2,
				warranty: 0,
				name: "2nd Layer of Building Felt",
				material: 0.12,
				time: 36,
				labor: 0,
				total: 0,
			},
			{
				id: 4.3,
				warranty: 0,
				name: "Metal Lath",
				material: 0.99,
				time: 9,
				labor: 0,
				total: 0,
			},
			{
				id: 4.4,
				warranty: 0,
				name: "Metal Lath Fasteners",
				material: 0.12,
				time: 7.5,
				labor: 0,
				total: 0,
			},
			{
				id: 4.5,
				warranty: 0,
				name: 'Leveling & Scratch Coat - 1/2"',
				material: 0.59,
				time: 281,
				labor: 0,
				total: 0,
			},
			{
				id: 4.6,
				warranty: 0,
				name: 'Type S Mortar (Setting Stone) - 1/2"',
				material: 0.59,
				time: 252,
				labor: 0,
				total: 0,
			},
		],
		finalTotal: {
			material: 0,
			time: 0,
			labor: 0,
			total: 0,
		},
	},
];
